<template>
  <div class="stpe_one order_list" id="orderlist">
    <div class="step_title">
      <span
        v-for="item in orderType"
        :class="{ act: item.selected }"
        @click="checkOrderType(item)"
        >{{ item.text }}</span
      >
    </div>
    <!-- 单笔下单 -->
    <span v-show="orderType[0].selected">
      <div class="service_category">
        <div class="service_category_info" style="padding-bottom: 14px">
          <div class="info_settype jiaju" style="margin-bottom: 10px">
            <div class="type_name"><span class="xing">*</span>商品类目</div>
            <div class="type_content">
              <div
                class="category"
                style="
                  height: 70px;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                "
                @click="checkToClass(item)"
                :class="{ isCheck: item.isSelected }"
                v-for="(item, index) in categoryCommodities"
                :key="index"
              >
                <div class="jiaju" style="width: 48px; height: 48px">
                  <img :src="item.icon" alt />
                </div>
                <span
                  style="display: inline-flex; height: 14px; line-height: 14px"
                  >{{ item.name }}</span
                >
              </div>
            </div>
          </div>
          <div class="info_settype" v-if="serviceTypeList.length">
            <div class="type_name type-title">
              <span class="xing">*</span>服务类型
            </div>
            <div class="type_content service-type-info">
              <div
                class="service_type"
                v-for="(item, index) in serviceTypeList"
                @click="checkedServiceType(item)"
                :class="{ selected: item.isSelected }"
              >
                <div>{{ item.name }}</div>
              </div>
            </div>
          </div>
          <div
            v-if="serviceTypeList.length"
            class="type-tips"
            style="
              position: static;
              margin-left: 83px;
              margin-top: 6px;
              height: auto;
            "
          >
            {{ tipsText }}
          </div>
          <div style="display: none"></div>
        </div>
      </div>
      <div class="step_one_main">
        <div class="service_category" v-show="commodityInfo">
          <!-- <div class="service_category" > -->
          <div class="step_title">客户信息</div>
          <div class="service_category_info user-info-box">
            <!-- 地址识别 -->
            <div class="address-module">
              <div class="address-module-inp">
                <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="粘贴文本，自动识别客户信息。例如：聚师傅， 130**** 四川省成都市**区**街道**小区**楼**号"
                  v-model="addressBefore"
                ></el-input>
              </div>
              <div style="display: flex; justify-content: space-between">
                <el-button
                  class="identify"
                  :disabled="!addressBefore"
                  @click="parseClick"
                  >客户地址识别</el-button
                >
                <el-button
                  class="identify"
                  :disabled="!addressBefore"
                  @click="pickupParseClick"
                  >提货地址识别</el-button
                >
                <el-button style="margin-left: 8px" @click="addressBefore = ''"
                  >清空</el-button
                >
              </div>
            </div>

            <div style="width: 674px">
              <div class="kehu-box">
                <div class="info_settype">
                  <div class="type_name">
                    <span class="xing">*</span>客户姓名
                  </div>
                  <div class="type_content">
                    <el-input
                      v-model="$store.state.immediateData.customerName"
                      :maxlength="100"
                      @input="iscustomerInfo"
                      placeholder="请输入"
                    ></el-input>
                  </div>
                </div>

                <div class="info_settype">
                  <div class="type_name">
                    <span class="xing">*</span>客户手机
                  </div>
                  <div class="type_content">
                    <el-input
                      v-model="$store.state.immediateData.customerPhone"
                      placeholder="请输入"
                      maxlength="11"
                      @input="iscustomerInfo"
                    ></el-input>
                  </div>
                </div>
              </div>

              <div
                class="kehu-box address-box"
                :style="{
                  marginBottom: $store.state.immediateData.areaTips
                    ? '9px'
                    : '16px',
                }"
              >
                <div style="display: flex">
                  <div class="info_settype address" style="margin-right: 0">
                    <div class="type_name">
                      <span class="xing">*</span>客户地址
                    </div>
                    <div class="type_content">
                      <el-cascader
                        v-model="$store.state.immediateData.areaCode"
                        :options="cityOptions"
                        :props="cityCodeProps"
                        placeholder="选择客户地址"
                        @change="
                          checkCity(
                            $store.state.immediateData.areaCode,
                            'customer'
                          )
                        "
                        clearable
                        filterable
                      ></el-cascader>
                    </div>
                    <!-- <div class="type-tips" style="left: 83px; bottom: -23px">
                    {{ areaTips }}
                  </div> -->
                  </div>
                  <div class="type_content" style="margin-left: 8px">
                    <el-autocomplete
                      ref="autocomplete"
                      class="inline-input"
                      v-model="$store.state.immediateData.address"
                      :fetch-suggestions="querySearch"
                      placeholder="请输入内容"
                      popper-class="address_picker"
                      @blur="
                        onBlur($store.state.immediateData.address, 'customer')
                      "
                    >
                      <!-- @input="getSearchList" -->
                      <!-- @select="handleSelect" -->
                      <template slot-scope="{ item }">
                        <div @click="checkPoi(item, 'customer')">
                          <span style="float: left">{{ item.name }}</span>
                          <span
                            v-if="item.type.includes('省级地名')"
                            style="
                              float: right;
                              color: #8492a6;
                              font-size: 13px;
                            "
                            >{{ item.pname }}</span
                          >
                          <span
                            v-else
                            style="
                              float: right;
                              color: #8492a6;
                              font-size: 13px;
                            "
                            >{{ item.cityname }} {{ item.adname }}</span
                          >
                        </div>
                      </template>
                    </el-autocomplete>
                    <!-- <el-select
                    v-model="$store.state.immediateData.address"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入详细地址"
                    :remote-method="getSearchList"
                    :loading="loading"
                    popper-class="address_picker"
                  >
                    <el-option
                      v-for="item in searchList"
                      :key="item.id"
                      :label="item.address + ',' + item.name"
                      :value="item.address + ',' + item.name"
                    >
                      <div @click="checkPoi(item, 'customer')">
                        <span style="float: left">{{ item.name }}</span>
                        <span
                          v-if="item.type.includes('省级地名')"
                          style="float: right; color: #8492a6; font-size: 13px"
                          >{{ item.pname }}</span
                        >
                        <span
                          v-else
                          style="float: right; color: #8492a6; font-size: 13px"
                          >{{ item.cityname }} {{ item.adname }}</span
                        >
                      </div>
                    </el-option>
                  </el-select> -->
                  </div>
                </div>
                <div
                  class="kehu-tips"
                  v-if="$store.state.immediateData.areaTips"
                >
                  {{ $store.state.immediateData.areaTips }}
                  <!-- 下单方服务类型说明文字，由后台进行配置 -->
                </div>
              </div>
              <div class="kehu-box">
                <div class="info_settype">
                  <div class="type_name"><span class="xing">*</span>住几楼</div>
                  <div class="type_content">
                    <el-select
                      v-model="$store.state.immediateData.floorsNumber"
                      filterable
                      placeholder="请选择"
                      @change="calculatePrice"
                    >
                      <el-option
                        v-for="item in floorNum"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="radio_input">
                  <div class="type_name">
                    <span class="xing">*</span>有无电梯
                  </div>
                  <el-radio
                    v-model="$store.state.immediateData.isLift"
                    @change="iscustomerInfo('lift')"
                    label="true"
                    border
                    >有</el-radio
                  >
                  <el-radio
                    v-model="$store.state.immediateData.isLift"
                    @change="iscustomerInfo('lift')"
                    label="false"
                    border
                    >无</el-radio
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="service_category">
            <div class="step_title huowu-tit">
              物流信息
              <span
                ><img
                  style="width: 20px; height: 18px; margin-right: 8px"
                  src="@/assets/img/notice.png"
                  alt=""
                />即时服务需要货物“已到提货点”或是“客户家”</span
              >
            </div>
            <div
              class="service_category_info user-info-box"
              style="flex-direction: column"
            >
              <div class="kehu-box huowu">
                <div class="info_settype">
                  <div class="type_name">货物位置</div>
                  <div class="type_content" style="color: #3455d3">
                    {{
                      $store.state.immediateData.isJishiTihuoFei
                        ? "已到提货点"
                        : "已到客户家"
                    }}
                  </div>
                </div>

                <div
                  style="display: flex"
                  v-if="$store.state.immediateData.isJishiTihuoFei"
                >
                  <div class="info_settype address" style="margin-right: 0">
                    <div class="type_name">
                      <span class="xing">*</span>提货地址
                    </div>
                    <div class="type_content">
                      <el-cascader
                        v-model="$store.state.immediateData.pickupAreaCode"
                        :options="cityOptions"
                        :props="cityCodeProps"
                        placeholder="选择所在城市"
                        @change="
                          checkCity(
                            $store.state.immediateData.pickupAreaCode,
                            'pickUp'
                          )
                        "
                        clearable
                        filterable
                      ></el-cascader>
                    </div>
                    <!-- <div class="type-tips" style="left: 83px; bottom: -23px">
                    {{ areaTips }}
                  </div> -->
                  </div>
                  <div class="type_content" style="margin-left: 8px">
                    <el-autocomplete
                      ref="autocompletes"
                      class="inline-input"
                      v-model="$store.state.immediateData.pickupAddress"
                      :fetch-suggestions="picupSearch"
                      placeholder="请输入内容"
                      popper-class="address_picker"
                      @blur="
                        onBlur(
                          $store.state.immediateData.pickupAddress,
                          'pickUp'
                        )
                      "
                    >
                      <!-- @select="handleSelect" -->
                      <template slot-scope="{ item }">
                        <div @click="checkPoi(item, 'pickUp')">
                          <span style="float: left">{{ item.name }}</span>
                          <span
                            v-if="item.type.includes('省级地名')"
                            style="
                              float: right;
                              color: #8492a6;
                              font-size: 13px;
                            "
                            >{{ item.pname }}</span
                          >
                          <span
                            v-else
                            style="
                              float: right;
                              color: #8492a6;
                              font-size: 13px;
                            "
                            >{{ item.cityname }} {{ item.adname }}</span
                          >
                        </div>
                      </template>
                    </el-autocomplete>
                    <!-- <el-select
                    v-model="$store.state.immediateData.pickupAddress"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入详细地址"
                    :remote-method="getPickUpList"
                    :loading="loading"
                    popper-class="address_picker"
                  >
                    <el-option
                      v-for="item in pickUpList"
                      :key="item.id"
                      :label="item.address + ',' + item.name"
                      :value="item.address + ',' + item.name"
                    >
                      <div @click="checkPoi(item, 'pickUp')">
                        <span style="float: left">{{ item.name }}</span>
                        <span
                          v-if="item.type.includes('省级地名')"
                          style="float: right; color: #8492a6; font-size: 13px"
                          >{{ item.pname }}</span
                        >
                        <span
                          v-else
                          style="float: right; color: #8492a6; font-size: 13px"
                          >{{ item.cityname }} {{ item.adname }}</span
                        >
                      </div>
                    </el-option>
                  </el-select> -->
                  </div>
                </div>
              </div>

              <div class="kehu-box huowu">
                <div class="info_settype">
                  <div class="type_name">物流公司</div>
                  <div class="type_content">
                    <el-select
                      v-model="$store.state.immediateData.logisticsCompany"
                      filterable
                      remote
                      reserve-keyword
                      placeholder="请输入物流公司名称"
                      :remote-method="getLogisticsCompany"
                      :loading="loading"
                      @change="getLogisticsInfo"
                    >
                      <el-option
                        v-for="item in logisticsCompany"
                        :key="item.value"
                        :label="item.companyName"
                        :value="item.companyCode"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <div class="info_settype" style="margin-right: 8px">
                  <div class="type_name">
                    <span
                      class="xing"
                      v-if="$store.state.immediateData.isJishiTihuoFei"
                      >*</span
                    >物流单号
                  </div>
                  <div class="type_content">
                    <el-input
                      v-model="$store.state.immediateData.logisticsNo"
                      placeholder="请输入"
                      @input="getLogisticsInfo"
                    ></el-input>
                  </div>
                </div>
                <div class="info_settype">
                  物流信息：<el-tooltip
                    v-if="LogisticsInfo.context"
                    class="item"
                    effect="dark"
                    :content="LogisticsInfo.context"
                    placement="top"
                    popper-class="wuliutooltip"
                  >
                    <span class="wulxinx" style="width: 280px">{{
                      LogisticsInfo.context || "暂无"
                    }}</span>
                  </el-tooltip>
                  <span v-else class="wulxinx" style="width: 280px">
                    暂无
                  </span>
                </div>
              </div>
              <div class="kehu-box" style="margin-bottom: 16px">
                <div class="info_settype">
                  <div class="type_name">
                    <span
                      class="xing"
                      v-if="$store.state.immediateData.isJishiTihuoFei"
                      >*</span
                    >物流电话
                  </div>
                  <div class="type_content">
                    <el-input
                      v-model="$store.state.immediateData.logisticsPhone"
                      placeholder="请输入"
                      maxlength="11"
                      @input="iscustomerInfo"
                    ></el-input>
                  </div>
                </div>

                <div class="info_settype" style="margin-right: 36px">
                  <div class="type_name">提货码</div>
                  <div class="type_content">
                    <el-input
                      v-model="$store.state.immediateData.pickupCode"
                      placeholder="请输入"
                      maxlength="30"
                      @input="iscustomerInfo"
                    ></el-input>
                  </div>
                </div>

                <div class="info_settype">
                  <div class="type_name">
                    <span class="xing">*</span>服务时段
                  </div>
                  <div class="type_content">
                    <el-popover
                      popper-class="service_time"
                      placement="bottom-start"
                      width="280"
                      trigger="click"
                      @hide="setServiceTime"
                    >
                      <div class="time-content">
                        <el-radio-group v-model="radio1">
                          <div
                            class="time-content-label"
                            v-for="(item, index) in serviceTimeList"
                            v-if="istimeShow(item)"
                          >
                            <el-radio-button :label="index"
                              >{{ item.text }}
                              <i class="el-icon-arrow-right"></i
                            ></el-radio-button>
                            <el-checkbox-group
                              v-model="$store.state.immediateData.checkList"
                              size="medium"
                            >
                              <div
                                class="period"
                                v-for="it in item.timeList"
                                v-if="index == radio1"
                              >
                                <el-checkbox
                                  v-if="timeShow(item.date, it.endTime)"
                                  :label="
                                    item.date +
                                    '|' +
                                    it.startTime +
                                    '-' +
                                    it.endTime
                                  "
                                  >{{
                                    it.startTime + "-" + it.endTime
                                  }}</el-checkbox
                                >
                                <div
                                  v-if="
                                    onEndTime(item, it) &&
                                    it.endTime ==
                                      item.timeList[item.timeList.length - 1]
                                        .endTime
                                  "
                                  style="text-align: center; margin-top: 80px"
                                >
                                  当前时间段没有可选时间
                                </div>
                              </div>
                            </el-checkbox-group>
                          </div>
                        </el-radio-group>
                      </div>
                      <el-input
                        slot="reference"
                        v-model="$store.state.immediateData.showServiceTime"
                        placeholder="请选择"
                        @change="serviceTime = true"
                        :readonly="true"
                      ></el-input>
                    </el-popover>
                  </div>
                  <div
                    class="type-tips"
                    style="bottom: -25px; left: 81px; white-space: nowrap"
                  >
                    请与客户沟通服务时间，确保所选服务时段客户在家
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="service_category">
            <div class="service_category_info map-box" id="map" ref="map">
              <div class="yujishij" v-if="$store.state.immediateData.distance">
                提货距离客户<span
                  >{{
                    ($store.state.immediateData.distance / 1000).toFixed(2)
                  }}Km</span
                >
                预计耗时<span>{{
                  formatDuring($store.state.immediateData.transportTime) || "/"
                }}</span>
              </div>
            </div>
          </div>
          <!-- </div> -->
          <!-- <div v-show="!goodsInfo"> -->
          <div>
            <div
              class="service_category"
              v-for="(item, index) in $store.state.immediateData.orderItems"
              :key="index"
              @click="whatNumber(item, index)"
            >
              <div class="step_title">
                商品信息{{ index + 1 }}
                <svg
                  @click="removeCommodity(item)"
                  class="icon icona_xiadan_delete"
                  aria-hidden="true"
                  v-if="
                    $store.state.immediateData.orderItems.length == 1
                      ? false
                      : true
                  "
                >
                  <use xlink:href="#icona_xiadan_delete" />
                </svg>
              </div>
              <div class="service_category_info goods-detail">
                <div class="goods-info">
                  <div class="info_settype">
                    <div class="type_name commodity">
                      <span class="xing">*</span>商品图
                    </div>
                    <div
                      class="type_content"
                      :class="{ img_delete: item.fileList.length != 0 }"
                    >
                      <div
                        class="library-box"
                        v-if="libraryList.rows.length > 0"
                        @click="
                          libraryList.rows.length > 0
                            ? (goodsLibrary = true)
                            : (goodsLibrary = false)
                        "
                      ></div>
                      <svg
                        class="icon icona_xiadan_delete"
                        aria-hidden="true"
                        @click="deleteImg(index)"
                      >
                        <use xlink:href="#icona_xiadan_delete" />
                      </svg>
                      <a-upload
                        :action="baseApl + '/common/common/upload_file'"
                        listType="picture-card"
                        :fileList="item.fileList"
                        @preview="handlePreview"
                        @change="handleChange"
                        :beforeUpload="beforeUpload"
                        :disabled="libraryList.rows.length > 0"
                        class="upload"
                      >
                        <div v-if="item.fileList.length < 1">
                          <a-icon type="plus" />
                          <div class="ant-upload-text">图片</div>
                        </div>
                      </a-upload>
                      <a-modal
                        :visible="previewVisible"
                        :footer="null"
                        @cancel="handleCancel"
                      >
                        <img
                          alt="example"
                          style="width: 100%"
                          :src="previewImage"
                        />
                      </a-modal>
                    </div>
                  </div>

                  <div class="info_settype" style="margin-top: 13px">
                    <div class="type_name">安装视频</div>
                    <div class="type_content">
                      <div
                        class="upload-video"
                        :class="{ video_delete: item.videoList.length != 0 }"
                      >
                        <svg
                          class="icon iconz_pop_close"
                          aria-hidden="true"
                          @click="deleteVideo(index)"
                        >
                          <use xlink:href="#iconz_pop_close" />
                        </svg>
                        <a-upload
                          :action="baseApl + '/common/common/upload_file'"
                          :videoList="item.videoList"
                          @change="handleVideoChange"
                          :beforeUpload="beforeVideoUpload"
                          class="video_up"
                        >
                          <div v-if="item.videoList.length < 1">
                            <a-button class="upload_video">
                              <a-icon type="upload" />安装视频（选传）
                              <span class="tishi">视频不超过500M</span>
                            </a-button>
                          </div>
                        </a-upload>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="goods-text">
                  <div class="kehu-box">
                    <div class="info_settype">
                      <div class="type_name">
                        <span class="xing">*</span>商品类别
                      </div>
                      <div class="type_content">
                        <el-cascader
                          v-model="item.goodsTypeId"
                          :options="goodsTypeList"
                          :props="goodsTypeProps"
                          @change="checkGoodsType"
                          placeholder="请选择"
                          clearable
                          filterable
                        ></el-cascader>
                      </div>
                    </div>
                    <div class="input_numbers">
                      <span class="xing">*</span>商品数量
                      <el-input-number
                        class="number_input"
                        v-model="item.count"
                        @change="calculatePrice"
                        step-strictly
                        :min="1"
                        :max="999"
                        label="描述文字"
                      ></el-input-number>
                    </div>
                  </div>

                  <div class="kehu-box">
                    <div class="info_settype">
                      <div class="type_name">
                        <span class="xing">*</span>商品名称
                      </div>
                      <div class="type_content">
                        <el-input
                          v-model="item.name"
                          placeholder="请输入"
                        ></el-input>
                      </div>
                    </div>

                    <div class="info_settype">
                      <div class="type_name">包装方式</div>
                      <div class="type_content">
                        <el-input
                          v-model="item.packingMethod"
                          placeholder="请输入"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="info_settype">
                    <div class="type_name">商品描述</div>
                    <div class="type_content">
                      <el-input
                        class="miaosu"
                        v-model="item.description"
                        placeholder="请输入需要师傅注意的事项"
                      ></el-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="add_commodity" @click="addCommodity()">
              <svg class="icon icona_xiadan_addshangpin" aria-hidden="true">
                <use xlink:href="#icona_xiadan_addshangpin" /></svg
              >添加商品
            </div>

            <div
              class="service_category"
              v-if="$store.state.immediateData.isJishiTihuoFei"
            >
              <!-- <div class="service_category"> -->
              <div class="step_title huowu-tit">
                提货信息
                <span
                  ><img
                    style="width: 20px; height: 18px; margin-right: 8px"
                    src="@/assets/img/notice.png"
                    alt=""
                  />请注意：师傅根据您所选“提货车型”去提货，如超出车辆运输能力，会导致二次提货费</span
                >
              </div>
              <div class="service_category_info user-info-box tihuo-box">
                <div
                  class="kehu-box"
                  style="display: flex; align-items: center"
                >
                  <div class="info_settype" style="margin-right: 0px">
                    <div class="type_name">
                      <span class="xing">*</span>提货车型
                    </div>
                    <div class="type_content">
                      <el-select
                        v-model="$store.state.immediateData.pickupCarTypeId"
                        filterable
                        placeholder="请选择"
                        @change="checkTruckType"
                      >
                        <el-option
                          v-for="item in pickupTruckType"
                          :label="item.name + ' 0m³-' + item.maxSpace + 'm³'"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                  <el-tooltip
                    v-if="SuggestedModel.goodsName"
                    class="item"
                    effect="dark"
                    :content="
                      '您选择的商品包含特殊商品：' +
                      SuggestedModel.goodsName +
                      ',' +
                      '建议选择“' +
                      SuggestedModel.carSpec +
                      '”以上车型'
                    "
                    placement="top"
                    popper-class="wuliutooltip"
                  >
                    <div class="tips tihuo">
                      您选择的商品包含特殊商品：<span
                        >{{ SuggestedModel.goodsName }},</span
                      >建议选择<span>“{{ SuggestedModel.carSpec }}”</span
                      >以上车型
                    </div>
                  </el-tooltip>
                </div>

                <div
                  class="tihuo-info"
                  v-if="$store.state.immediateData.pickupTruckTypeData"
                >
                  <div class="imgs" v-if="srcList.length">
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="item"
                      :preview-src-list="srcList"
                      v-for="(item, index) in srcList"
                      :z-index="index"
                    >
                    </el-image>
                  </div>
                  <div
                    class="tihuo-des"
                    :style="{ maxWidth: setMaxwidth(srcList.length) }"
                  >
                    <div class="tihuo-label">
                      <div>
                        载货体积:<span
                          >0m³-{{
                            $store.state.immediateData.pickupTruckTypeData
                              .maxSpace
                          }}m³</span
                        >
                      </div>
                      <div>
                        载货长*宽*高（米）<span
                          >{{
                            $store.state.immediateData.pickupTruckTypeData
                              .maxLong || "/"
                          }}*{{
                            $store.state.immediateData.pickupTruckTypeData
                              .maxWidth || "/"
                          }}*{{
                            $store.state.immediateData.pickupTruckTypeData
                              .maxHeight || "/"
                          }}</span
                        >
                      </div>
                    </div>
                    <div class="tihuo-label">
                      <div style="padding-left: 11px">
                        可装载:<span>{{
                          $store.state.immediateData.pickupTruckTypeData.load ||
                          "暂无说明"
                        }}</span>
                      </div>
                    </div>
                    <div class="tihuo-label">
                      <div>
                        不可装载:<span>{{
                          $store.state.immediateData.pickupTruckTypeData
                            .unLoad || "暂无说明"
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="service_category">
              <div class="step_title huowu-tit">补充信息</div>
              <div
                class="service_category_info user-info-box"
                style="flex-direction: column"
              >
                <div class="kehu-box">
                  <div class="info_settype">
                    <div class="type_name">
                      <span class="xing">*</span>包装件数
                    </div>
                    <div class="type_content">
                      <el-input
                        v-model="$store.state.immediateData.packingCount"
                        placeholder="请输入"
                        oninput="value=value.replace(/[^\d]/g,'')"
                        maxlength="11"
                        @input="calculatePrice"
                      ></el-input>
                    </div>
                  </div>

                  <div class="info_settype" style="margin-right: 36px">
                    <div class="type_name">订单体积</div>
                    <div class="type_content">
                      <!-- <el-input
                      v-model="$store.state.immediateData.totalVolume"
                      placeholder="请输入"
                      oninput="value=value.replace(/[^\d]/g,'')"
                      maxlength="11"
                      @input="calculatePrice"
                    ></el-input> -->
                      <el-input
                        v-model="$store.state.immediateData.totalVolume"
                        placeholder="请输入"
                        maxlength="11"
                        oninput="value=value.replace(/[^0-9.]/g,'')"
                        @input="watchNumber"
                      ></el-input>
                    </div>
                  </div>

                  <div class="info_settype">
                    <div class="type_name"><span class="xing">*</span>核销</div>
                    <div class="type_content hexiao">
                      <el-radio-group
                        v-model="$store.state.immediateData.verifType"
                        style="height: 21px; line-height: 34px"
                      >
                        <el-radio label="NOT">不需要</el-radio>
                        <el-radio label="MIAO">喵师傅</el-radio>
                        <el-radio label="WANG">汪师傅</el-radio>
                      </el-radio-group>
                    </div>
                  </div>
                </div>
                <div class="kehu-box">
                  <div class="info_settype">
                    <div class="type_name">订单备注</div>
                    <div class="type_content bucong-desc">
                      <el-input
                        style="width: 598px !important"
                        v-model="$store.state.immediateData.remark"
                        placeholder="请输入"
                        maxlength="255"
                      ></el-input>
                    </div>
                  </div>
                  <div class="info_settype">
                    <div class="type_name">核销单号</div>
                    <div class="type_content">
                      <el-input
                        v-model="$store.state.immediateData.verifOrderNo"
                        placeholder="请输入"
                        maxlength="24"
                      ></el-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="service_category">
              <div class="step_title huowu-tit">
                问题联系人<span style="color: #ffad16"
                  >订单服务进度信息我们将通过此号码通知您，服务中若出现异常问题师傅也将通过该号码与您联系。</span
                >
              </div>
              <div class="service_category_info user-info-box">
                <div class="kehu-box">
                  <div class="info_settype">
                    <div class="type_name"><span class="xing">*</span>姓名</div>
                    <div class="type_content">
                      <el-input
                        v-model="$store.state.immediateData.userName"
                        placeholder="请输入"
                        maxlength="25"
                      ></el-input>
                    </div>
                  </div>

                  <div class="info_settype" style="margin-right: 36px">
                    <div class="type_name">
                      <span class="xing">*</span>联系电话
                    </div>
                    <div class="type_content">
                      <el-input
                        v-model="$store.state.immediateData.userPhone"
                        placeholder="请输入"
                        oninput="value=value.replace(/[^\d]/g,'')"
                        maxlength="11"
                      ></el-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="speed_order_price" v-if="!priceshow">
              <div class="price_tabs">
                <div
                  v-for="item in $store.state.immediatePrice.orderServiceFees"
                >
                  <span>{{ item.name }}：</span>¥{{ item.fee }}
                </div>
                <!-- <div><span>保险费：</span>¥20.00</div> -->
                <div>
                  <span>师傅服务费：</span>¥{{
                    $store.state.immediatePrice.workerFee
                  }}
                </div>
              </div>
              <div class="total_price">
                <div
                  class="kehu_address"
                  v-if="$store.state.immediateData.address"
                >
                  <div>
                    客户地址：{{
                      ($store.state.immediateData.addressText || "") +
                      $store.state.immediateData.address
                    }}
                  </div>
                  <div>
                    客户手机：{{ $store.state.immediateData.customerPhone }}
                  </div>
                </div>
                <div class="total_price_text">
                  <div>
                    <span>应付总额：</span
                    ><i>¥{{ $store.state.immediatePrice.totalFee }}</i>
                  </div>
                </div>
              </div>
            </div>

            <div class="speed_order_price" v-else>
              <div class="price_tabs">
                <div><span>平台服务费：</span>¥0.00</div>
                <div><span>保险费：</span>¥0.00</div>
                <div><span>师傅服务费：</span>¥0.00</div>
              </div>
              <div class="total_price">
                <div
                  class="kehu_address"
                  v-if="$store.state.immediateData.address"
                >
                  <div>
                    客户地址：{{
                      $store.state.immediateData.addressText +
                      $store.state.immediateData.address
                    }}
                  </div>
                  <div>
                    客户手机：{{ $store.state.immediateData.customerPhone }}
                  </div>
                </div>
                <div class="total_price_text">
                  <div><span>应付总额：</span><i>¥0.00</i></div>
                </div>
              </div>
            </div>

            <el-button
              class="nextStep"
              @click="nextStep()"
              :loading="confirmLoading"
              >下一步</el-button
            >
          </div>
          <!-- </div> -->
        </div>
      </div>
    </span>
    <batch-order
      v-show="orderType[1].selected"
      ref="batchOrder"
      orderType="TIMELY"
    ></batch-order>

    <!-- 商品库弹窗 -->
    <el-dialog
      title="商品图片"
      :visible.sync="goodsLibrary"
      width="30%"
      class="complaint goodsLibrary"
      @close="initializeLibrary()"
    >
      <div>
        <div class="complaint-img">
          <a-upload
            :action="baseApl + '/common/common/upload_file'"
            listType="picture-card"
            @change="goodsHandleChange"
            :fileList="fileList"
            :beforeUpload="beforeUpload"
          >
            <div>
              <a-button class="upload_video">
                <a-icon type="upload" />上传图片
              </a-button>
            </div>
          </a-upload>
        </div>
        <div class="library-title">商品图库</div>
        <div class="library-condition type_content">
          <el-cascader
            v-model="libraryNum"
            :options="goodsTypeLists"
            :props="goodsTypeProps"
            @change="checkLibraryType"
            placeholder="请选择"
            clearable
          ></el-cascader>
          <el-input
            placeholder="请输入商品名称"
            class="library-search"
            v-model="libraryName"
            @change="getGoodsLibraryList"
          >
            <i
              slot="prefix"
              @click="getGoodsLibraryList()"
              class="el-input__icon el-icon-search"
            ></i>
          </el-input>
        </div>
        <div class="libraryList">
          <div
            class="item"
            v-for="(item, index) in libraryList.rows"
            :key="index"
            @click="checkGoods(item)"
          >
            <img :src="item.imgUrl" alt />
            <div>{{ item.name }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Bus from "@/utils/bus.js";
import { setTimeout } from "timers";
import AddressParse from "address-parse";
import { coordinateConversion, getZoom } from "@/utils/util";
import $ from "jquery";
import batchOrder from "@/components/user/modules/batchOrder";
import { getAction } from "@/api/manage";
import { arithmeticMultiply, arithmeticDivide } from "@/utils/util";

export default {
  components: {
    batchOrder,
  },
  data() {
    return {
      orderType: [
        { text: "单笔下单", selected: true },
        { text: "批量下单", selected: false },
      ],
      confirmLoading: false,
      serviceTypeList: [],
      categoryCommodities: [],
      commodityInfo: false,
      goodsInfo: true,
      radio: "true", //必须事字符串
      previewVisible: false,
      previewImage: "",
      fileList: [],
      videoList: [],
      floorNum: [{ value: 1, label: "1层" }],
      commodityType: "",
      orderItems: [
        {
          fileList: [],
          videoList: [],
          goodsTypeId: "",
          name: "",
          count: "",
          packingMethod: "",
          description: "",
        },
      ],
      srcList: [
        // "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
        // "https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg",
        // "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg",
        // "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg",
      ],
      num: 0,
      areaTips: "",
      cityValue: [],
      cityOptions: [],
      goodsTypeList: [],
      goodsTypeLists: [], // 商品库
      goodsTypeProps: { expandTrigger: "hover", value: "id", label: "name" },
      cityCodeProps: { expandTrigger: "hover", value: "code", label: "name" },
      goodsNum: 0,
      webToken: {
        WEB_TOKEN: Cookies.get("token"),
      },
      priceshow: true,
      immediatePrice: {
        orderServiceFees: [],
      },
      assetsSources: null,
      assetsSources: null,
      deleteBtn: false,
      baseApl: process.env.VUE_APP_BASE_API,
      logisticsCompany: [],
      LogisticsInfo: {},
      goodsLibrary: false, // 控制商品库显示隐藏
      libraryList: {
        rows: [],
      }, // 商品库数据
      libraryName: "", // 商品库搜索条件
      libraryNum: "", // 商品库商品id
      totalVolume: "1",
      tipsText: "", // 服务类型提示
      SuggestedModel: {
        // goodsName:'',
        // carSpec:''
      },
      eventVectorSource: null,
      // eventVectorSources:null,
      pickupTruckType: [],
      addressBefore: "",
      addressAfter: {},
      addressAfterCode: [],
      mainJS: {},
      serviceTimeList: [],
      serviceTime: false,
      checkList: [],
      radio1: 0,
      searchList: [],
      pickUpList: [],
      loading: false,
      drivingList: [],
      drivingData: {},
      zoom: 0,
      estimatedTime: 0,
    };
  },
  // 接收注入的数据
  inject: ["reload"],
  activated() {
    var _this = this;
    var data = {
      url: "speedOrder",
      step: 1,
    };
    Bus.$emit("val", data);
    this.orderInit();
    this.getPickupTruckType();

    this.getUserInfo();
    this.getLogisticsCompany();
    this.getLogisticsInfo();
    this.querySuggestedModel();
    this.getGoodsType();
    _this.$store.state.defaultUrl = "";
    // if (Cookies.get("token") != undefined) {
    // 获取城市
    this.$fetch(`/common/api/area`).then((res) => {
      if (res.code == 0) {
        _this.cityOptions = res.data;
        if (this.$store.state.immediateData.areaCode) {
          console.log(this.$store.state.immediateData.areaCode);
          console.log(1111111111111111111111111);
          this.checkCity(this.$store.state.immediateData.areaCode, "identify");
        }
      } else {
        this.$message(res.message);
      }
    });
    if (this.$store.state.immediateData.goodsTypeId) this.getServiceType();
    this.getServiceTime();

    // 获取商品类目
    this.$fetch(`/common/api/goods_type/top_class`).then((res) => {
      if (res.code == 0) {
        res.data.map((i) => {
          i.isSelected = false;
          if (i.id == this.$store.state.immediateData.goodsTypeId) {
            i.isSelected = true;
          }
        });
        _this.categoryCommodities = res.data;
      } else {
        this.$message(res.message);
      }
    });

    if (Cookies.get("token") != undefined) {
      _this.getGoodsLibraryList();
    }
    if (this.$store.state.immediatePrice.orderServiceFees.length != 0) {
      this.priceshow = false;
    }
    this.iscustomerInfo();
    this.getEstimatedTime();
  },
  created() {
    this.initFloorNumber();
  },
  watch: {
    zoom(val, oval) {
      if (val.toString().includes(".")) {
        if (val > oval) {
          this.mainJS.map.getView().setZoom(Math.ceil(val));
        } else {
          this.mainJS.map.getView().setZoom(parseInt(val.toString()));
        }
      }
    },
    commodityInfo(val) {
      console.log(val);
      if (val) {
        setTimeout(() => {
          if (!this.mainJS.map) {
            this.setMap();
          } else {
            this.mainJS.map.render();
            this.removeFeature();
          }
        }, 500);
      }
    },
    // totalVolume(val) {
    //   console.log(this.totalVolume);
    //   if (this.isRealNum(val)) {
    //     if (Number(val) <= 0) {
    //       this.$store.state.immediateData.totalVolume = "";
    //       this.totalVolume = "";
    //     }
    //     if (val.indexOf(".") != -1) {
    //       this.$store.state.immediateData.totalVolume = val.split(".")[0];
    //       this.totalVolume = val.split(".")[0];
    //     }
    //     this.calculatePrice();
    //   } else {
    //     this.totalVolume = "";
    //   }
    // },
  },
  methods: {
    // 保留两位小数
    watchNumber(e) {
      if (e.split(".").length == 3) {
        this.$store.state.immediateData.totalVolume = e.substr(0, e.length - 1);
      } else {
        if (e.split(".")[1]) {
          // this.markupPrice = Math.floor(e * 10000) / 10000;
          this.$store.state.immediateData.totalVolume = arithmeticDivide(
            Math.floor(arithmeticMultiply(e, 100)),
            100
          );
        }
      }
      this.calculatePrice();
    },
    // 切换订单类型
    checkOrderType(e) {
      this.$alert("更换下单方式会导致已添加的商品丢失，确定切换吗？", "提示", {
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback: (action) => {
          if (action == "confirm") {
            this.orderInits();
            // this.$router.go(0);
            this.orderType.map((i) => {
              i.selected = false;
            });
            e.selected = true;
          }
        },
      });
    },
    querySearch(queryString, cb) {
      console.log(queryString);
      if (!queryString) this.$store.state.immediateData.lastTimeCustomer = "";
      this.getSearchList(queryString);
      var restaurants = this.searchList;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    picupSearch(queryString, cb) {
      console.log(queryString);
      if (!queryString) this.$store.state.immediateData.lastTimepickUp = "";
      this.getPickUpList(queryString);
      var restaurants = this.pickUpList;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    onBlur(e, type, identify) {
      console.log(e);
      console.log(type);
      let _this = this;
      let orderData = this.$store.state.immediateData;
      if (
        type == "customer" &&
        orderData.lng &&
        orderData.lastTimeCustomer &&
        e.split(orderData.lastTimeCustomer)[0]
      ) {
        _this.$alert("地址只能在详细地址后面补充", "提示", {
          showCancelButton: false,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          callback: (action) => {
            console.log(action);
            if (action == "confirm" || action == "cancel") {
              // this.$router.go(0);
              orderData.address = "";
              orderData.lng = "";
              orderData.lat = "";
              _this.setMapPath();
            }
          },
        });
      }
      if (
        type == "pickUp" &&
        orderData.pickUpLat &&
        orderData.lastTimepickUp &&
        e.split(orderData.lastTimepickUp)[0]
      ) {
        _this.$alert("地址只能在详细地址后面补充", "提示", {
          showCancelButton: false,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          callback: (action) => {
            if (action == "confirm" || action == "cancel") {
              // this.$router.go(0);
              orderData.pickupAddress = "";
              orderData.pickUpLng = "";
              orderData.pickUpLat = "";
              _this.setMapPath();
            }
          },
        });
      }

      let addressText;
      if (type == "customer")
        addressText = this.$store.state.immediateData.addressText || "";
      else
        addressText = this.$store.state.immediateData.pickupAddressText || "";
      let params = {
        key: "JJOBZ-ZLGKD-KLL4R-HSAYO-3BQAO-SAF4R", // 聚师傅企业webkey
        // key:process.env.VUE_APP_MAP_KEY,
        // city: addressText.split(",")[1],
        address: addressText + e,
        // address: e,
        // batch: "10",
        output: "jsonp",
      };
      $.ajax({
        type: "get",
        dataType: "jsonp",
        data: params,
        jsonp: "callback",
        jsonpCallback: "QQmap",
        url: "https://apis.map.qq.com/ws/geocoder/v1/",
        success: function (json) {
          console.log(json);
          if (json.status == 0) {
            // _this.checkPoi({ location: json.pois[0].location }, "customer");
            json.result.location = `${json.result.location.lng},${json.result.location.lat}`;
            let result = json.result;
            if (identify == "customer") {
              _this.$store.state.immediateData.address = json.result.title;
              _this.$store.state.immediateData.lastTimeCustomer =
                json.result.title;
            }
            if (identify == "pickUp") {
              _this.$store.state.immediateData.pickupAddress =
                json.result.title;
              _this.$store.state.immediateData.lastTimepickUp =
                json.result.title;
            }
            if (result.location && type === true && identify == "customer")
              return _this.checkPoi(result, "customer");
            if (result.location && type === true && identify == "pickUp")
              return _this.checkPoi(result, "pickUp");

            if (orderData.pickUpLat && type == "pickUp") return false;
            if (orderData.lat && type == "customer") return false;
            if (result.location) _this.checkPoi(result, type, identify);
          } else {
            _this.$alert(
              "当前输入的地址未查到经纬度，请在下拉选择一个",
              "提示",
              {
                showCancelButton: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                callback: (action) => {
                  if (action == "confirm") {
                    // this.$router.go(0);
                  }
                },
              }
            );
          }
        },
      });
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    setMapPath() {
      let orderData = this.$store.state.immediateData;
      // if (orderData.lat && orderData.pickUpLat && orderData.isJishiTihuoFei) {
      if (orderData.lat && orderData.pickUpLat) {
        let origin = orderData.lng + "," + orderData.lat;
        let destination = orderData.pickUpLng + "," + orderData.pickUpLat;
        this.getPlan(origin, destination);
        // } else if (orderData.lat && !orderData.isJishiTihuoFei) {
      } else if (orderData.lat) {
        let origin = orderData.lng + "," + orderData.lat;
        this.setCustomerpoint(origin, "customer");
      } else if (orderData.pickUpLat) {
        let destination = orderData.pickUpLng + "," + orderData.pickUpLat;
        this.setCustomerpoint(destination, "pickup");
      } else {
        this.removeFeature();
      }
    },
    setCustomerpoint(origin, type) {
      console.log(origin);
      let lntlat = coordinateConversion(origin.split(","), 4326, 3857);
      let _this = this;
      this.removeFeature();
      // 设置层级,位置
      this.mainJS.map.getView().animate({
        // zoom: getZoom(origin),
        center: lntlat,
        duration: "500",
      });
      let feature = new ol.Feature({
        geometry: new ol.geom.Point(lntlat),
        name: type == "customer" ? "客户位置" : "提货点",
        type: type,
        data: {
          callback: function (params, callbackParams, e) {
            // _this.isCenter(callbackParams, "event");
            console.log(3333);
          },
          callbackParams: { a: "1" },
        },
      });
      _this.eventVectorSource = new ol.source.Vector();

      _this.eventVectorSource.addFeatures([feature]);
      let eventLayer = new ol.layer.Vector({
        source: _this.eventVectorSource,
        style: _this.setPointStyle,
        zIndex: 100,
        attribute: `group-name`,
      });
      _this.mainJS.map.addLayer(eventLayer);
    },
    // 获取用户信息
    getUserInfo() {
      let _this = this;
      if (_this.$store.state.immediateData.userName == "") {
        // 用户信息
        this.$fetch(`/user/api/customer`).then((res) => {
          if (res.code == 0) {
            _this.$store.state.immediateData.userName = res.data.nickname;
            _this.$store.state.immediateData.userPhone = res.data.username;
          } else {
            // this.$message(res.message);
          }
        });
      }
    },
    // 加载地图
    setMap() {
      let _this = this;
      this.mainJS.baseMap = new ol.layer.Tile({
        source: new ol.source.XYZ({
          // url: '//webrd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}',
          url: "//webrd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}",
        }),
      });
      this.mainJS.center = coordinateConversion(
        [104.047244, 30.543346000000014],
        4326,
        3857
      );
      console.log(this.mainJS.center);
      //视图
      this.mainJS.view = new ol.View({
        center: this.mainJS.center,
        // projection: 'EPSG:4326',
        minZoom: 5,
        maxZoom: 18,
        // zoom: 17,
        zoom: 10,
      });
      //地图主体
      this.mainJS.map = new ol.Map({
        layers: [this.mainJS.baseMap],
        controls: [new ol.control.FullScreen()], //如果不设置 controls ，地图会默认设置
        view: this.mainJS.view,
        target: this.$refs.map,
      });
      this.setMapPath();
      this.mainJS.map.on("moveend", function (e) {
        _this.zoom = _this.mainJS.map.getView().getZoom(); //获取当前地图的缩放级别
      });
    },
    // 设置路经规划
    setRoutePlanning(gisData, distance) {
      // console.log(gisData);
      let _this = this;
      this.removeFeature();
      this.assetsSources = new ol.source.Vector();
      let assetsVector = new ol.layer.Vector({
        source: _this.assetsSources,
        style: new ol.style.Style({
          fill: new ol.style.Fill({
            color: "rgba(0,118,206,0.1)",
            // color: '#0076ce',
          }),
          stroke: new ol.style.Stroke({
            color: "#63CF4E",
            width: 3,
          }),
        }),
        attribute: `group-type`,
      });
      _this.mainJS.map.addLayer(assetsVector);

      let polygons = new ol.geom.LineString(gisData);
      let features = new ol.Feature({
        geometry: polygons,
        data: {
          callback: function (params, callbackParams, e) {
            console.log(11111111);
          },
          callbackParams: { a: "1121" },
        },
      });
      _this.assetsSources.addFeature(features);
      // console.log(features.getGeometry());
      // 中心点
      // console.log(features.getGeometry().getFlatMidpoint());
      console.log(getZoom(distance));
      // 设置层级,位置
      this.mainJS.map.getView().animate({
        // zoom: getZoom(distance),
        zoom: 10,
        center: features.getGeometry().getFlatMidpoint(),
        duration: "500",
      });

      let feature = [];
      _this.eventVectorSource = new ol.source.Vector();
      gisData.map((i, index) => {
        if (i == gisData[0] || i == gisData[gisData.length - 1]) {
          console.log(i);
          feature.push(
            new ol.Feature({
              geometry: new ol.geom.Point(i),
              name: i == gisData[0] ? "客户位置" : "提货点",
              type: i == gisData[0] ? "customer" : "pickup",
              data: {
                callback: function (params, callbackParams, e) {
                  // _this.isCenter(callbackParams, "event");
                  console.log(3333);
                },
                callbackParams: { a: "1" },
              },
            })
          );
        }
      });
      // _this.eventVectorSource = new ol.source.Vector();
      _this.eventVectorSource.addFeatures(feature);
      let eventLayer = new ol.layer.Vector({
        source: _this.eventVectorSource,
        style: _this.setPointStyle,
        zIndex: 100,
        attribute: `group-name`,
      });
      _this.mainJS.map.addLayer(eventLayer);

      // 拖拽
      let translate = new ol.interaction.Translate({
        //拖拽移动interaction
        features: new ol.Collection([feature[0]]), //拖拽的为选择的要素
      });
      let translate1 = new ol.interaction.Translate({
        //拖拽移动interaction
        features: new ol.Collection([feature[1]]), //拖拽的为选择的要素
      });
      translate.on("translateend", function (f) {
        console.log(f); //拖拽完成事件，可以获取拖拽后的要素
      });
      // 添加拖动动作
      // _this.mainJS.map.addInteraction(translate);
      // _this.mainJS.map.addInteraction(translate1);
    },
    // 设置点的样式
    setPointStyle(feature) {
      console.log(feature);
      let style = new ol.style.Style({
        image: new ol.style.Icon({
          anchor: [0.5, 0.5],
          src:
            feature.values_.type == "customer"
              ? require("@/assets/img/icon-customer.png")
              : feature.values_.type == "pickup"
              ? require("@/assets/img/icon-pickup.png")
              : "",
          size: [24, 28],
          // color: "#0076ce",
        }),
        stroke: new ol.style.Stroke({
          color: "#888",
          width: 2,
          lineDash: [4, 8],
        }),
        //文本样式
        text: new ol.style.Text({
          offsetY: 22,
          //对齐方式
          textAlign: "center",
          //文本基线
          textBaseline: "middle",
          //字体样式
          font: "normal 14px 微软雅黑",
          //文本内容
          text: feature.get("name"),
          // text: '利泰华' + '\n' + '锦绣网格',
          //填充样式
          fill: new ol.style.Fill({
            color: "#2F3133",
          }),
          //笔触
          stroke: new ol.style.Stroke({
            color: "#ffffff",
            width: 3,
          }),
        }),
      });
      return style;
    },
    // 删除地图上的数据
    removeFeature() {
      // console.log(this.mainJS.map);
      // console.log(this.eventVectorSource);
      // console.log(this.assetsSources);
      // console.log(this.eventVectorSource.getFeatures());
      // console.log(this.assetsSources.getFeatures());
      // this.mainJS.map.removeLayer(this.eventVectorSource)
      // this.mainJS.map.removeLayer(this.assetsSources)
      if (this.eventVectorSource) {
        this.eventVectorSource.getFeatures().map((i) => {
          this.eventVectorSource.removeFeature(i);
        });
      }
      // if (this.eventVectorSources) {
      //   this.eventVectorSources.getFeatures().map((i) => {
      //     this.eventVectorSources.removeFeature(i);
      //   });
      // }
      if (this.assetsSources) {
        this.assetsSources.getFeatures().map((i) => {
          this.assetsSources.removeFeature(i);
        });
      }
    },
    // 初始化楼层数
    initFloorNumber() {
      for (let i = 1; i < 101; i++) {
        this.floorNum[i - 1] = { value: i, label: `${i}层` };
      }
    },
    // 获取提货车型
    getPickupTruckType() {
      this.$fetch(`/common/api/car_type/list_no_page`).then((res) => {
        if (res.code == 0) {
          console.log(res);
          this.pickupTruckType = res.data;
          if (this.$store.state.immediateData.pickupTruckTypeData)
            this.checkTruckType(
              this.$store.state.immediateData.pickupTruckTypeData.id
            );
          if (this.$store.state.immediateData.pickupCarTypeId)
            this.checkTruckType(
              this.$store.state.immediateData.pickupCarTypeId
            );
        }
      });
    },
    // 选择车型
    checkTruckType(e) {
      console.log(e);
      console.log(this.pickupTruckType);
      this.calculatePrice();
      for (let i of this.pickupTruckType) {
        if (i.id == e) {
          console.log(i.img);
          if (i.img) {
            // 最多只显示4张图片
            this.srcList = i.img.split(",");
            this.srcList.map((i) => {
              if (this.srcList.length > 4) this.srcList.pop();
            });
          } else this.srcList = [];
          return (this.$store.state.immediateData.pickupTruckTypeData = i);
        }
      }
      // setTimeout(()=>{
      // this.calculatePrice()
      // },500)
    },
    // 解析点击
    parseClick() {
      if (!this.addressBefore) {
        return;
      }
      this.$store.state.immediateData.areaCode = [];
      let orderData = this.$store.state.immediateData.areaCode;
      const result = AddressParse.parse(this.addressBefore);
      console.log(result);
      this.addressAfter = result.length ? result[0] : {};
      let address = this.addressAfter;
      let all = this.cityOptions;
      this.$store.state.immediateData.customerName = address.name;
      this.$store.state.immediateData.customerPhone = address.mobile;
      // this.$store.state.immediateData.address = address.details;
      if (address.details) {
        this.$store.state.immediateData.addressText =
          address.province + "," + address.city + "," + address.area;
        this.onBlur(
          address.province +
            "," +
            address.city +
            "," +
            address.area +
            "," +
            address.details,
          true,
          "customer"
        );
        // this.getSearchList(
        //   address.province +
        //     "," +
        //     address.city +
        //     "," +
        //     address.area +
        //     "," +
        //     address.details
        // );
        this.getSearchList(address.details);
      }

      this.addressAfterCode = [];
      let prov = null;
      let city = null;
      let area = null;
      prov = all.find((item) => {
        return (
          item.name.indexOf(address.province) > -1 ||
          address.province.indexOf(item.name) > -1
        );
      });
      city = prov
        ? prov.children.find((item) => {
            return (
              item.name.indexOf(address.city) > -1 ||
              address.city.indexOf(item.name) > -1
            );
          })
        : null;
      area = city
        ? city.children.find((item) => {
            return (
              item.name.indexOf(
                address.area.substr(0, address.area.length - 1)
              ) > -1 || address.area.indexOf(item.name) > -1
            );
          })
        : null;
      console.log(orderData);
      prov ? orderData.push(prov.code) : "";
      city ? orderData.push(city.code) : "";
      area ? orderData.push(area.code) : "";

      this.checkCity(orderData, "identify");
      console.log(orderData);
      this.iscustomerInfo("1");
    },
    // 提货地址识别
    pickupParseClick() {
      if (!this.addressBefore) {
        return;
      }
      this.$store.state.immediateData.pickupAreaCode = [];
      let orderData = this.$store.state.immediateData.pickupAreaCode;
      const result = AddressParse.parse(this.addressBefore);
      console.log(result);
      this.addressAfter = result.length ? result[0] : {};
      let address = this.addressAfter;
      let all = this.cityOptions;
      // this.$store.state.immediateData.customerName = address.name;
      this.$store.state.immediateData.logisticsPhone = address.mobile;
      // this.$store.state.immediateData.address = address.details;
      if (address.details) {
        this.$store.state.immediateData.pickupAddressText =
          address.province + "," + address.city + "," + address.area;
        this.onBlur(
          address.province +
            "," +
            address.city +
            "," +
            address.area +
            "," +
            address.details,
          true,
          "pickUp"
        );
        // this.getSearchList(
        //   address.province +
        //     "," +
        //     address.city +
        //     "," +
        //     address.area +
        //     "," +
        //     address.details
        // );
        this.getSearchList(address.details);
      }

      this.addressAfterCode = [];
      let prov = null;
      let city = null;
      let area = null;
      prov = all.find((item) => {
        return (
          item.name.indexOf(address.province) > -1 ||
          address.province.indexOf(item.name) > -1
        );
      });
      city = prov
        ? prov.children.find((item) => {
            return (
              item.name.indexOf(address.city) > -1 ||
              address.city.indexOf(item.name) > -1
            );
          })
        : null;
      area = city
        ? city.children.find((item) => {
            return (
              item.name.indexOf(
                address.area.substr(0, address.area.length - 1)
              ) > -1 || address.area.indexOf(item.name) > -1
            );
          })
        : null;
      console.log(orderData);
      prov ? orderData.push(prov.code) : "";
      city ? orderData.push(city.code) : "";
      area ? orderData.push(area.code) : "";

      this.checkCity(orderData);
      console.log(orderData);
      // this.iscustomerInfo("1");
    },
    // 判断输入值是否为数字
    isRealNum(val) {
      // isNaN()函数 把空串 空格 以及NUll 按照0来处理 所以先去除，
      if (val === "" || val == null) {
        return false;
      }
      if (!isNaN(val)) {
        //对于空数组和只有一个数值成员的数组或全是数字组成的字符串，isNaN返回false，例如：'123'、[]、[2]、['123'],isNaN返回false,
        //所以如果不需要val包含这些特殊情况，则这个判断改写为if(!isNaN(val) && typeof val === 'number' )
        return true;
      } else {
        return false;
      }
    },
    // 判断客户信息是否填全
    iscustomerInfo(type) {
      if (type) this.calculatePrice();
      let userinfo = this.$store.state.immediateData;
      if (
        !!userinfo.customerName &&
        !!userinfo.customerPhone &&
        !!userinfo.areaCode[userinfo.areaCode.length - 1] &&
        !!userinfo.address &&
        !!userinfo.isLift
      ) {
        this.goodsInfo = false;
        // this.getGoodsType();
      }
    },
    // 判断是否重新下单
    orderInit() {
      if (this.$store.state.immediateData.customerName == "") {
        // this.$router.go(0);
        this.commodityInfo = false;
        this.goodsInfo = true;
        this.categoryCommodities.map((i) => {
          i.isSelected = false;
        });
        this.serviceTypeList.map((i) => {
          i.isSelected = false;
        });
      }
    },
    // 获取服务类型
    getServiceType() {
      let _this = this;
      // 获取服务类型
      this.$fetch(`/common/api/service_type/list_by_good_type`, {
        goodTypeId: this.$store.state.immediateData.goodsTypeId,
      }).then((res) => {
        if (res.code == 0) {
          for (let i of res.data) {
            i.isSelected = false;
            if (i.id == _this.$store.state.immediateData.serviceType) {
              i.isSelected = true;
              _this.tipsText = i.description;
              _this.commodityInfo = true;
              var data = {
                url: "speedOrder",
                step: 2,
              };
              Bus.$emit("val", data);
            }
          }
          if (this.$store.state.immediateData.goodsTypeId)
            _this.serviceTypeList = res.data;
          // console.log(_this.serviceTypeList.filter(i=>i.id==this.$store.state.immediateData.serviceType))
          _this.checkedServiceType(
            _this.serviceTypeList.filter(
              (i) => i.id == this.$store.state.immediateData.serviceType
            )[0]
          );

          // _this.tipsText = res.data[0].description;
        } else {
          this.$message(res.message);
        }
      });
    },
    // 获取商品类别
    getGoodsType() {
      let _this = this;
      // 获取商品类别
      this.$fetch(`/common/api/goods_type`, {
        // areaCode:
        //   this.$store.state.immediateData.areaCode[
        //     this.$store.state.immediateData.areaCode.length - 1
        //   ],
      }).then((res) => {
        if (res.code == "0") {
          // _this.goodsTypeList = res.data[0].children;
          console.log(res);
          _this.goodsTypeLists = res.data;
          if (res.data) {
            res.data.map((i) => {
              if (i.id == _this.$store.state.immediateData.goodsTypeId) {
                _this.goodsTypeList = i.children;
              }
            });
          } else {
            _this.goodsTypeList = [];
          }
        } else {
          this.$message(res.message);
        }
      });
    },
    // 选择商品类目
    checkToClass(item) {
      if (this.commodityInfo) {
        this.$alert("更换服务类目会导致已添加的商品丢失，确定切换", "提示", {
          showCancelButton: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          callback: (action) => {
            if (action == "confirm") {
              this.$router.go(0);
            }
          },
        });
      } else {
        var orderData = this.$store.state.immediateData;
        orderData.orderItems.map((i) => {
          i.goodsTypeId = null;
        });
        this.categoryCommodities.map((i) => {
          i.isSelected = false;
        });
        item.isSelected = true;
        this.$store.state.immediateData.goodsTypeId = item.id;
        this.getGoodsType();
        this.getServiceType();
      }
    },
    // 获取商品库数据
    getGoodsLibraryList() {
      this.$post(
        `/user/api/goods/list?goodsTypeId=${
          !this.libraryNum ? "" : this.libraryNum
        }&keyWord=${this.libraryName}&pageIndex=1&pageNum=999`
      ).then((res) => {
        if (res.code == 0) {
          console.log(res);
          this.libraryList = res.data;
        } else {
          this.$message(res.message);
        }
      });
    },
    // 初始化商品库数据
    initializeLibrary() {
      this.libraryNum = "";
      this.getGoodsLibraryList();
    },
    // 选择商品库商品
    checkGoods(item) {
      this.$store.state.immediateData.orderItems[this.goodsNum].goodsTypeId =
        item.goodsTypeId;
      this.$store.state.immediateData.orderItems[this.goodsNum].name =
        item.name;
      this.$store.state.immediateData.orderItems[this.goodsNum].fileList.push({
        thumbUrl: item.imgUrl,
        name: item.name,
        status: "done",
        uid: "-1",
        response: { data: { url: item.imgUrl } },
      });
      this.goodsLibrary = false;
      this.calculatePrice();
      this.querySuggestedModel();
    },
    // 切换服务类型
    checkedServiceType(item = {}) {
      console.log(item);
      this.$message.closeAll();
      if (this.$store.state.immediateData.goodsTypeId == "") {
        this.$message.error("请先选择商品类目");
        return;
      }
      this.commodityInfo = true;
      var data = {
        url: "speedOrder",
        step: 2,
      };
      Bus.$emit("val", data);
      for (let i of this.serviceTypeList) {
        i.isSelected = false;
      }
      item.isSelected = !item.isSelected;
      this.tipsText = item.description;
      this.$store.state.immediateData.isJishiTihuoFei = item.isJishiTihuoFei;
      // if(item.isJishiTihuoFei) this.getPickupTruckType()
      this.$store.state.immediateData.takeDeliveryFee = item.takeDeliveryFee;
      this.$store.state.immediateData.serviceType = item.id;
      this.calculatePrice();
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    // 判断下标是第几个
    whatNumber(item, index) {
      this.goodsNum = index;
    },
    // 判断上传是否为图片
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      if (!isJPG) {
        this.$message.error("图片只能上传jpg、png格式");
      }
      //   const isLt2M = file.size / 1024 / 1024 < 2
      //   if (!isLt2M) {
      //     this.$message.error('Image must smaller than 2MB!')
      //   }

      return isJPG;
    },
    // 判断上传是否为视频
    beforeVideoUpload(file) {
      const isVideo = file.type === "video/mp4";
      if (!isVideo) {
        this.$message.error("视频只能上传mp4格式");
      }
      const isLt100M = file.size / 1024 / 1024 < 100;
      if (!isLt100M) {
        this.$message.error("视频不能超过100M");
        this.$store.state.immediateData.orderItems[this.goodsNum].videoList =
          [];
      }

      return isVideo && isLt100M;
    },
    // 删除图片
    deleteImg(index) {
      console.log(index);
      this.$store.state.immediateData.orderItems[index].fileList = [];
    },
    // 删除视频
    deleteVideo(index) {
      this.$store.state.immediateData.orderItems[index].videoList = [];
      $(".upload-video").on("click", ".iconz_pop_close", function () {
        $(this)
          .siblings(".video_up")
          .find(".ant-upload-list-item-done")
          .remove();
      });
    },
    // 商品信息上传图片
    handleChange({ fileList }) {
      if (
        fileList[0].type === "image/jpeg" ||
        fileList[0].type === "image/png"
      ) {
        this.$store.state.immediateData.orderItems[this.goodsNum].fileList =
          fileList;
      } else {
        this.$store.state.immediateData.orderItems[this.goodsNum].fileList = [];
      }
    },
    // 商品库上传图片
    goodsHandleChange({ fileList }) {
      let list = [];
      if (
        fileList[0].type === "image/jpeg" ||
        fileList[0].type === "image/png"
      ) {
        list.push(fileList[fileList.length - 1]);
        this.fileList = list;
        this.$store.state.immediateData.orderItems[this.goodsNum].fileList =
          this.fileList;
        this.goodsLibrary = false;
      } else {
        this.fileList = [];
        this.$store.state.immediateData.orderItems[this.goodsNum].fileList = [];
      }
    },
    handleVideoChange(info) {
      let fileList = [...info.fileList];
      fileList = fileList.slice(-1);
      fileList = fileList.map((file) => {
        if (file.response) {
          // Component will show file.url as link
          file.url = file.response.url;
        }
        return file;
      });
      // 判断上传视频大小
      if (fileList[0].size / 1024 / 1024 < 100) {
        if (
          fileList[0].type === "video/mp4" &&
          !fileList[0].size / 1024 / 1024 < 100
        ) {
          this.$store.state.immediateData.orderItems[this.goodsNum].videoList =
            fileList;
        } else {
          return;
        }
      } else {
        return;
      }
    },
    inputNumChange(value) {
      this.$store.state.immediateData.packingCount = value;
      this.calculatePrice();
    },
    // 获取城市说明文字
    getAreaTips(item) {
      this.$fetch(`/common/api/goods_type/goods_area_description`, {
        areaCode: item[item.length - 1],
      }).then((res) => {
        if (res.code == 0) {
          this.$store.state.immediateData.areaTips = res.data;
        }
      });
    },
    //获取选中的父级节点
    find(arr, code) {
      console.log(arr);
      console.log(code);
      let stock = [];
      let going = true;
      var warker = function (arr, code) {
        arr.forEach((item) => {
          if (!going) return;
          stock.push(item.name);
          if (item.code == code) {
            going = false;
          } else if (item.children) {
            warker(item.children, code);
          } else {
            stock.pop();
          }
        });
        if (going) stock.pop();
      };
      warker(arr, code);
      console.log(stock);
      return stock.join(",");
    },
    // 选择城市
    checkCity(item, type) {
      let orderData = this.$store.state.immediateData;
      console.log(item);
      console.log(this.find(this.cityOptions, item[item.length - 1]));

      if (type == "customer") {
        orderData.addressText = this.find(
          this.cityOptions,
          item[item.length - 1]
        );
        orderData.address = "";
        this.getSearchList(orderData.address);
        this.calculatePrice();
      } else if (type == "pickUp") {
        orderData.pickupAddressText = this.find(
          this.cityOptions,
          item[item.length - 1]
        );
        orderData.pickupAddress = "";
        this.getPickUpList(orderData.pickupAddress);
      }
      // this.$store.state.immediateData.address=''
      // 判断该区域是否开通服务
      if (type == "customer" || type == "identify") {
        this.$fetch(`/common/api/area/jishi_area_control`, {
          goodsTypeId: orderData.goodsTypeId,
          areaCode: item[item.length - 1],
        }).then((res) => {
          if (res.code == 0) {
            console.log(res);
            this.getAreaTips(item);
            this.iscustomerInfo();
          } else {
            this.$alert("该区域暂未开通服务，无法下单", "提示", {
              confirmButtonText: "确定",
              type: "warning",
              callback: () => {
                orderData.areaCode = "";
              },
            });
          }
        });
      }
      this.calculatePrice();
      // this.getGoodsType();
    },
    // 获取物流公司
    getLogisticsCompany(e) {
      console.log(e);
      let params = {
        name: e,
        pageNo: 1,
        pageSize: 20,
      };
      this.$fetch("/common/api/wuliu/wuliu_company_search", params).then(
        (res) => {
          if (res.code == 0) {
            this.logisticsCompany = res.data.records;
          }
        }
      );
    },
    // 获取物流信息
    getLogisticsInfo() {
      let params = {
        companyCode: this.$store.state.immediateData.logisticsCompany,
        kuaidiNum: this.$store.state.immediateData.logisticsNo,
      };
      this.$fetch("/common/api/wuliu/kuaidi_search", params).then((res) => {
        if (res.code == 0) {
          // console.log(JSON.parse(res.data));
          let data = JSON.parse(res.data).data;
          console.log(data);
          this.LogisticsInfo = data[0];
        } else {
          this.LogisticsInfo = "";
        }
      });
    },
    // 查询建议车型
    querySuggestedModel() {
      let orderData = this.$store.state.immediateData;
      // 删除类目会出现undefined 用filter可以删除
      let ids = orderData.orderItems.filter((i) => i.goodsTypeId);
      console.log(ids);
      let params = {
        goodsIds: ids.map((i) => i.goodsTypeId).join(","),
      };
      this.$fetch("/common/api/goods_type/query_car_by_goods_id", params).then(
        (res) => {
          console.log(res);
          if (res.code == 0) this.SuggestedModel = res.data || {};
        }
      );
    },
    // 选择商品类别
    checkGoodsType(value) {
      if (value)
        this.$store.state.immediateData.orderItems[this.goodsNum].goodsTypeId =
          value[value.length - 1];
      this.calculatePrice();
      this.querySuggestedModel();
    },
    // 商品库选择类别
    checkLibraryType(value) {
      this.libraryNum = value[value.length - 1];
      this.getGoodsLibraryList();
    },
    // 判断是否是整数
    isInteger(num) {
      if (!isNaN(num) && num % 1 === 0) {
        return true;
      } else {
        return false;
      }
    },
    // 进入支付
    nextStep() {
      let _this = this;
      this.$message.closeAll();
      var orderData = this.$store.state.immediateData;
      var myreg = /^1[123456789]\d{9}$/;
      if (orderData.customerName == "")
        return this.$message.error("请输入客户姓名");
      if (!myreg.test(orderData.customerPhone))
        return this.$message.error("请输入合法手机号");
      if (orderData.areaCode == "")
        return this.$message.error("请选择客户地址");
      if (orderData.address == "") return this.$message.error("请输入详细地址");
      if (orderData.isLift == "") return this.$message.error("请选择有无电梯");
      if (orderData.isLift == "false" && !orderData.floorsNumber)
        return this.$message.error("请输入楼梯层数");
      if (orderData.pickupAreaCode == "" && orderData.isJishiTihuoFei)
        return this.$message.error("请选择提货地址");
      if (orderData.pickupAddress == "" && orderData.isJishiTihuoFei)
        return this.$message.error("请输入提货详细地址");
      if (
        orderData.logisticsNo == "" &&
        this.$store.state.immediateData.isJishiTihuoFei
      )
        return this.$message.error("请输入物流单号");
      if (
        orderData.logisticsPhone == "" &&
        this.$store.state.immediateData.isJishiTihuoFei
      )
        return this.$message.error("请输入物流电话");
      if (!orderData.showServiceTime)
        return this.$message.error("请输入服务时段");
      for (let i of orderData.orderItems) {
        if (i.fileList.length != 0) {
          i.imgUrl = i.fileList[0].response.data.url;
        }
        if (i.videoList.length != 0) {
          i.installVideoUrl = i.videoList[0].response.data.url;
        }
        if (i.imgUrl == "") return this.$message.error("请上传商品图片");
        if (i.goodsTypeId == "") return this.$message.error("请选择商品类别");
        if (i.name == "") return this.$message.error("请输入商品名称");
      }
      if (orderData.isJishiTihuoFei && !orderData.pickupCarTypeId)
        return this.$message.error("请输选择提货车型");
      if (orderData.packingCount == "0")
        return this.$message.error("包装件数不能为0");
      // if (!this.isInteger(orderData.totalVolume) ||orderData.totalVolume == "0") return this.$message.error("请输入整数的体积");
      if (orderData.userName == "")
        return this.$message.error("请输入问题联系人姓名");
      if (orderData.userPhone == "")
        return this.$message.error("请输入问题联系人电话");
      if (this.$store.state.immediatePrice.workerFee == 0) {
        this.$message.error("商品类目价格维护中，该类目暂时不能下单");
        orderData.orderItems.map((i) => {
          i.goodsTypeId = "";
        });
        return;
      }
      this.confirmLoading = true;
      var orderItems = [];
      for (let i of orderData.orderItems) {
        orderItems.push({
          name: i.name,
          count: i.count,
          goodsTypeId: i.goodsTypeId,
          description: i.description,
          imgUrl: i.imgUrl,
          installVideoUrl: i.installVideoUrl,
          packingMethod: i.packingMethod,
        });
      }
      console.log(orderData);
      let params = {
        goodsTypeId: orderData.goodsTypeId, //一级商品类目id
        serviceType: orderData.serviceType, //服务类型id
        customerName: orderData.customerName, //客户姓名
        customerPhone: orderData.customerPhone, //客户电话
        isLift: orderData.isLift, //是否有电梯
        floorsNumber: orderData.floorsNumber, //电梯层数
        areaCode: orderData.areaCode[orderData.areaCode.length - 1], //地区code
        lat: orderData.lat, //客户纬度
        lng: orderData.lng, //客户经度
        address: orderData.address, //联系地址
        pickupAreaCode:
          orderData.pickupAreaCode[orderData.pickupAreaCode.length - 1], // 提货地区code
        pickupAddress: orderData.pickupAddress, // 提货地址
        pickUpLat: orderData.pickUpLat, // 提货经度
        pickUpLng: orderData.pickUpLng, // 提货维度
        pickupDistance: orderData.distance, // 提货距离
        pickupCarTypeId: orderData.pickupCarTypeId, // 提货车型id
        pickupCode: orderData.pickupCode, // 提货码
        servicePeriodList: orderData.servicePeriodList, // 服务时间段
        orderItems: orderItems, //商品列表
        totalVolume: orderData.totalVolume, // 订单总体积
        packingCount: orderData.packingCount, //包装数量
        isArrival: orderData.isArrival, //是否到货
        logisticsNo: orderData.logisticsNo, //物流单号
        logisticsPhone: orderData.logisticsPhone, //物流电话
        logisticsCompany: orderData.logisticsCompany, //物流公司
        verifType: orderData.verifType, //是否核销
        verifOrderNo: orderData.verifOrderNo, //核销订单号
        expectedTime: orderData.expectedTime, //期望服务时间
        remark: orderData.remark, //备注
        userName: orderData.userName, //您的姓名
        userPhone: orderData.userPhone, //您的电话
        orderCartId: _this.$store.state.immediatePrice.orderCartId,
        transportTime: orderData.transportTime, //运输时间
      };

      this.$post("/order/api/order/add_jishi", params)
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            this.$router.push({
              path: "/placeorder/Orderpayment",
              query: {
                orderid: res.data.orderId,
              },
            });
            this.orderInits();
          }
        })
        .finally(() => {
          this.confirmLoading = false;
        });

      // return;
      // this.$router.push({
      //   path: "/placeorder/orderPay",
      //   query: {
      //     orderid: "6853935841346075347",
      //   },
      // });
    },
    // 下单信息初始化
    orderInits() {
      this.tipsText = "";
      this.$store.state.immediatePrice = {
        orderServiceFees: [],
      };
      // 下单完成后初始化即时下单对象
      this.$store.state.immediateData = {
        checkList: [], // 服务时段列表
        goodsTypeId: "", //一级商品类目id
        takeDeliveryFee: "", //是否含送货费
        isJishiTihuoFei: false, // 是否含有提货费
        serviceType: "", //服务类型id
        customerName: "", //客户姓名
        customerPhone: "", //客户电话
        isLift: "", //是否有电梯
        floorsNumber: "", //楼层数
        areaCode: [], //地区code
        address: "", //联系地址
        pickupAreaCode: [], //提货地址code
        pickupAddress: "", //提货地址
        addressText: "",
        orderItems: [
          //商品列表
          {
            fileList: [], //图片list
            videoList: [], //视频list
            imgUrl: "", //图片地址
            installVideoUrl: "", //视频地址
            goodsTypeIdList: [], //商品类别id数组
            goodsTypeId: "", //商品类别id
            name: "", //商品名称
            count: "1", //商品数量
            packingMethod: "", //包装方式
            description: "", // 商品描述
          },
        ],
        totalVolume: "1", // 订单总体积
        packingCount: "1", //包装数量
        isArrival: "true", //是否到货
        logisticsNo: "", //物流单号
        logisticsPhone: "", //物流电话
        logisticsCompany: "", //物流公司
        pickupCode: "", //提货码
        pickupAddress: "", //提货地址
        verifType: "NOT", //是否核销
        verifOrderNo: "", //核销订单号
        expectedTime: "", //期望服务时间
        remark: "", //备注
        userName: "", //您的姓名
        userPhone: "", //您的电话
        transportTime: "", //运输时间
      };
    },
    // 添加新的商品
    addCommodity() {
      this.$store.state.immediateData.orderItems.push({
        fileList: [], //图片list
        videoList: [], //视频list
        imgUrl: "", //视频地址
        installVideoUrl: "", //视频地址
        goodsTypeIdList: [], //商品类别id数组
        goodsTypeId: "", //商品类别id
        name: "", //商品名称
        count: "1", //商品数量
        packingMethod: "", //包装方式
        description: "", // 商品描述
      });
      this.calculatePrice();
    },
    // 删除商品
    removeCommodity(item) {
      var _this = this;
      this.$confirm("确认删除商品信息，删除后将无法恢复。", "", {
        confirmButtonText: "继续删除",
        cancelButtonText: "点错了",
        type: "warning",
      })
        .then(() => {
          _this.$store.state.immediateData.orderItems.remove(item);
          this.calculatePrice();
        })
        .catch(() => {});
    },
    // 计算价格
    calculatePrice() {
      var _this = this;
      var orderData = this.$store.state.immediateData;
      // orderData.totalVolume = _this.totalVolume;
      var orderItems = [];
      for (let i of orderData.orderItems) {
        orderItems.push({
          name: i.name,
          count: i.count,
          goodsTypeId: i.goodsTypeId,
        });
      }

      this.$post(`/order/api/order/jishi/price`, {
        goodsTypeId: orderData.goodsTypeId,
        serviceType: orderData.serviceType,
        areaCode: orderData.areaCode[orderData.areaCode.length - 1],
        totalVolume: orderData.totalVolume,
        orderItems: orderItems,
        count: orderData.packingCount,
        pickupCarTypeId: orderData.pickupCarTypeId,
        distance: orderData.distance,
        orderCartId: _this.$store.state.immediatePrice.orderCartId,
        isLift: orderData.isLift,
        floorsNumber: orderData.floorsNumber,
      }).then((res) => {
        if (res.code == 0) {
          console.log(res);
          _this.priceshow = false;
          _this.$store.state.immediatePrice = res.data;
        } else {
          // this.$message(res.message);
        }
      });
    },
    // 动态设置提货信息最大宽度
    setMaxwidth(length) {
      if (!length) return "950px";
      else if (length == 1) return "842px";
      else if (length == 2) return "734px";
      else if (length == 3) return "626px";
      else if (length == 4) return "518px";
    },
    // 获取服务时间段
    getServiceTime() {
      this.$fetch(`/order/api/order/service_period`).then((res) => {
        if (res.code == "0") {
          console.log(res);
          this.setServiceDay(res.data.currentTime, res.data.serviceTimeList);
        }
      });
    },
    getDate(time) {
      let date = "";
      if (!this.isRealNum(time)) date = time.toString().replace(/-/g, "/");
      else date = time;
      let whichDay = new Date(date).getDay(); // 周几 0是周日
      // let year = new Date(date).getFullYear(); // 年
      let month = new Date(date).getMonth() + 1; // 月 0是1月
      let day = new Date(date).getDate(); // 日
      return { whichDay: whichDay, month: month, day: day };
    },
    // 设置服务时间天
    setServiceDay(time, timeList) {
      let date = time.replace(/-/g, "/");
      let dateInfo = this.getDate(date);
      for (let i = 1; i <= 9; i++) {
        let dateTime = new Date(date);
        let temTime = dateTime.setDate(dateTime.getDate() + i);
        let temDate = this.getDate(temTime);
        this.serviceTimeList[i - 1] = {
          text: `${temDate.month}月${
            temDate.day.toString().length == 1 ? "0" + temDate.day : temDate.day
          }日 [周${this.setNumText(temDate.whichDay)}]`,
          date: new Date(temTime).toLocaleDateString().split("/").join("-"),
          timeList: timeList,
        };
      }
      this.serviceTimeList.unshift({
        text: `${dateInfo.month}月${
          dateInfo.day.toString().length == 1
            ? "0" + dateInfo.day
            : dateInfo.day
        }日 [周${this.setNumText(dateInfo.whichDay)}]`,
        date: new Date(date).toLocaleDateString().split("/").join("-"),
        timeList: timeList,
      });
      console.log(this.serviceTimeList);
    },
    // 数字替换为汉字
    setNumText(num) {
      if (num == 1) return "一";
      if (num == 2) return "二";
      if (num == 3) return "三";
      if (num == 4) return "四";
      if (num == 5) return "五";
      if (num == 6) return "六";
      if (num == 0) return "日";
    },
    timeShow(time, endTime) {
      let date = time.replace(/-/g, "/");
      if (new Date().getTime() - new Date(`${date} ${endTime}`).getTime() < 0)
        return true;
      else return false;
    },
    istimeShow(item) {
      // if (
      //   new Date().getTime() -
      //     new Date(
      //       `${item.date} ${item.timeList[item.timeList.length - 1].endTime}`
      //     ).getTime() <
      //   0
      // )
      //   return true;
      // else {
      //   this.radio1 = 1;
      //   return false;
      // }
      return true;
    },
    onEndTime(item, it) {
      if (it) {
        if (
          new Date().getTime() -
            new Date(
              `${item.date.replace(/-/g, "/")} ${it.endTime}`
            ).getTime() <
          0
        )
          return false;
        else return true;
      }
    },
    // 服务时间选择后
    setServiceTime() {
      let checkList = this.$store.state.immediateData.checkList;
      let servicePeriodList = checkList.map((i) => {
        return {
          date: i.split("|")[0],
          startTime: i.split("|")[1].split("-")[0],
          endTime: i.split("|")[1].split("-")[1],
        };
      });
      this.$store.state.immediateData.servicePeriodList = servicePeriodList;
      console.log(checkList);
      if (checkList.length == 0) {
        this.$store.state.immediateData.showServiceTime = "";
        this.$forceUpdate();
      }
      if (checkList.length > 1) {
        let dateList = checkList.map((i) => {
          return new Date(
            `${i.split("|")[0].replace(/-/g, "/")} ${
              i.split("|")[1].split("-")[1]
            }`
          ).getTime();
        });
        let minDay = Math.min.apply(null, dateList);
        console.log(dateList);
        let temDate = this.getDate(minDay);
        let startTime = checkList[dateList.indexOf(minDay)]
          .split("|")[1]
          .split("-")[0];
        let endTime = checkList[dateList.indexOf(minDay)]
          .split("|")[1]
          .split("-")[1];
        this.$store.state.immediateData.showServiceTime = `${temDate.month}月${temDate.day}日 ${startTime}-${endTime} 共${dateList.length}个时段`;
        this.$forceUpdate();
      } else {
        if (checkList.length) {
          let date = checkList[0].split("|")[0];
          let temDate = this.getDate(date);
          let startTime = checkList[0].split("|")[1].split("-")[0];
          let endTime = checkList[0].split("|")[1].split("-")[1];
          this.$store.state.immediateData.showServiceTime = `${temDate.month}月${temDate.day}日 ${startTime}-${endTime}`;
          this.$forceUpdate();
        }
      }
      this.calculatePrice();
    },
    // 选择远程poi
    checkPoi(e, type) {
      console.log(e);
      console.log(type);
      if (type == "customer") {
        this.$store.state.immediateData.lat = e.location.split(",")[1]; // 客户地址纬度
        this.$store.state.immediateData.lng = e.location.split(",")[0]; // 客户地址经度
        this.$store.state.immediateData.lastTimeCustomer = e.name || e.title;
      } else {
        this.$store.state.immediateData.pickUpLat = e.location.split(",")[1]; // 提货地址纬度
        this.$store.state.immediateData.pickUpLng = e.location.split(",")[0]; // 提货地址经度
        this.$store.state.immediateData.lastTimepickUp = e.name || e.title;
      }
      setTimeout(() => {
        this.setMapPath();
      }, 500);
    },
    // 地址查询
    getSearchList(e) {
      console.log(e);
      console.log(this.$refs.autocomplete);

      let _this = this;
      this.loading = true;
      let addressText = this.$store.state.immediateData.addressText || "";
      let params = {
        key: process.env.VUE_APP_MAP_KEY,
        keywords: addressText + e,
        // keywords: "成都市新都区蜀龙路保利公园198丁香郡",
        batch: "10",
        output: "JSON",
        callback: "callback",
      };
      $.ajax({
        type: "get",
        dataType: "jsonp",
        data: params,
        url: "https://restapi.amap.com/v3/place/text",
        success: function (json) {
          console.log(json);
          if (json.info == "OK") {
            json.pois.map((i) => {
              i.value = i.name;
            });
            if (json.pois.length) {
              _this.searchList = json.pois;
              _this.$refs.autocomplete.suggestions = json.pois;
            }
            // _this.$forceUpdate()
            _this.loading = false;
            // if (type) {
            //   _this.checkPoi({ location: json.pois[0].location }, "customer");

            //   // _this.$store.state.immediateData.lat =
            //   //   json.pois[0].location.split(",")[1]; // 客户地址纬度
            //   // _this.$store.state.immediateData.lng =
            //   //   json.pois[0].location.split(",")[0]; // 客户地址经度
            // }
          } else _this.loading = false;
        },
      });
    },
    // 提货地址查询
    getPickUpList(e) {
      console.log(e);
      let _this = this;
      let addressText = this.$store.state.immediateData.pickupAddressText || "";
      this.loading = true;
      let params = {
        key: process.env.VUE_APP_MAP_KEY,
        keywords: addressText + e,
        // keywords: "成都市新都区蜀龙路保利公园198丁香郡",
        batch: "10",
        output: "JSON",
        callback: "callback",
      };
      $.ajax({
        type: "get",
        dataType: "jsonp",
        data: params,
        url: "https://restapi.amap.com/v3/place/text",
        success: function (json) {
          console.log(json);
          if (json.info == "OK") {
            json.pois.map((i) => {
              i.value = i.name;
            });
            if (json.pois.length) {
              _this.pickUpList = json.pois;
              _this.$refs.autocompletes.suggestions = json.pois;
            }
            _this.loading = false;
          } else _this.loading = false;
        },
      });
    },
    // 路经规划
    getPlan(origin, destination) {
      let _this = this;
      let params = {
        key: process.env.VUE_APP_MAP_KEY,
        origin: origin,
        destination: destination,
        extensions: "base",
      };
      $.ajax({
        type: "get",
        dataType: "jsonp",
        data: params,
        url: "https://restapi.amap.com/v3/direction/driving",
        success: function (json) {
          console.log(json);
          if (json.info == "OK") {
            _this.$store.state.immediateData.distance =
              json.route.paths[0].distance || 0;
            _this.$store.state.immediateData.transportTime =
              json.route.paths[0].duration * 1000;
            _this.drivingData = json.route.paths[0];
            _this.drivingList = json.route.paths[0].steps.map(
              (i) => i.polyline
            );
            _this.drivingList = _this.drivingList
              .join(";")
              .split(";")
              .map((i) => {
                return coordinateConversion(
                  [i.split(",")[0], i.split(",")[1]],
                  4326,
                  3857
                );
              });
            _this.setRoutePlanning(
              _this.drivingList,
              _this.drivingData.distance
            );
            _this.calculatePrice();
            _this.$forceUpdate();
          }
        },
      });
    },
    formatDuring(times) {
      if (!times) return null;
      let time = times + this.estimatedTime * 60 * 1000;
      let days = parseInt(time / (1000 * 60 * 60 * 24));
      let hours = parseInt((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = parseInt((time % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = ((time % (1000 * 60)) / 1000).toFixed();
      // // 格式 00天 00时 00分 00秒
      if (days < 10) {
        days = "0" + days;
      }
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      // return days + "天" + hours + "小时" + minutes + "分钟" + seconds + "秒";
      if (days[1] != 0) return days + "天" + hours + "小时" + minutes + "分钟";
      if (hours[1] != 0) return hours + "小时" + minutes + "分钟";
      if (minutes[1] != 0) return minutes + "分钟";
      if (seconds[1] != 0) return seconds + "秒";
      // return hours + "小时" + minutes + "分钟";
    },
    // 获取预计耗时
    getEstimatedTime() {
      getAction("user/api/customer/get_basic_time").then(({ data }) => {
        console.log(data);
        this.estimatedTime = data.data;
      });
    },
  },
};
</script>
<style lang="scss">
@import "./../_step_one.scss";
.map-box {
  .ol-control {
    padding: 0;
    button {
      width: 30px;
      height: 30px;
      font-size: 20px;
      background: #fff;
      color: #b4b7bc;
      margin: 0;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
      border-radius: 2px;
      cursor: pointer;
    }
  }
}

.service_time {
  padding: 6px 0;
}
.address_picker {
  width: auto !important;
  .el-select-dropdown__item {
    padding: 0;
    & > div {
      padding: 0 20px;
      width: 100%;
      height: 100%;
    }
  }
  .el-scrollbar__view {
    li {
      padding: 0;
      & > div {
        padding: 0 20px;
        width: 100%;
        // height: 100%;
        height: 34px;
      }
    }
  }
}
.wuliutooltip {
  background: #fff6e7 !important;
  color: #5e6066 !important;
  width: 232px;
  line-height: 16px;
  .popper__arrow {
    display: none !important;
  }
}
.time-content {
  height: 205px;
  position: relative;
  &::-webkit-scrollbar {
    display: none;
  }
  .el-radio-group {
    width: 100%;
    height: 205px;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .time-content-label {
    display: flex;
    // position: relative;

    .el-radio-button {
      width: 145px;
      border-right: 1px solid #dcdfe6;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-radio-button__inner {
        width: 100%;
        border: 0;
        padding: 12px 15px;
      }
    }
    .el-checkbox-group {
      position: absolute;
      left: 155px;
      top: 0;
      font-size: 14px;
    }
    &:last-child {
      .el-radio-button__inner {
        // border-bottom: 1px solid #dcdfe6;
      }
    }
    // .el-checkbox__label {
    //   font-size: 20px;
    //   line-height: 35px;
    // }
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #3455d3;
      border-color: #3455d3;
    }
    // .el-checkbox__input {
    //   height: 20px;
    //   vertical-align: text-bottom;
    // }
    .el-checkbox__inner:hover {
      border-color: #3455d3;
    }
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      background-color: #f5f7fa;
      border-color: transparent;
      color: #3455d3 !important;
      font-weight: bold;
    }
    .el-checkbox__input.is-checked + .el-checkbox__label,
    .el-radio-button__inner:hover {
      color: #3455d3;
      background-color: #f5f7fa;
      border-color: transparent;
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #3455d3 !important;
      background: transparent !important;
      font-weight: bold;
    }
    .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #3455d3;
    }
    .el-checkbox {
      display: flex;
      align-items: center;
      margin-bottom: 17px;
      margin-top: 0;
    }
  }
  .el-radio-button__inner {
    border-bottom: 0;
    border-radius: 0 !important;
  }
}
</style>
<style lang="scss" scoped>
.step_title {
  justify-content: flex-start;
  color: #909399;
  font-weight: 500;
  margin-top: 10px;
  span {
    cursor: pointer;
    border-bottom: 1px solid transparent;
  }
  span + span {
    margin-left: 40px;
  }
  .act {
    color: #2f3133;
    border-bottom: 1px solid #3455d3;
  }
}
.stpe_one {
  &/deep/.el-input__inner:hover {
    border-color: #3455d3 !important;
  }
  &/deep/.el-input .el-input__suffix {
    width: 25px;
  }
}
/deep/.el-input__icon {
  line-height: 32px;
}
#orderlist {
  .service_category {
    margin-top: 0;
  }
  .radio_input {
    &/deep/.el-radio.is-bordered {
      height: 30px !important;
      padding: 8px 12px 0 10px;
    }
  }
  .address {
    position: relative;
  }
  .type_content {
    flex-wrap: wrap;
    width: auto;
    .service_type {
      margin-top: 6px;
    }
    &/deep/.el-cascader {
      height: 34px;
      line-height: 34px;
    }

    // & /deep/ .number_input input {
    //   width: 153px !important;
    // }
  }
  & /deep/ .goodsLibrary .library-condition .el-input input {
    width: 100% !important;
  }
  & /deep/ .library-condition {
    .el-cascader {
      line-height: 34px;
    }
    .el-input__icon {
      line-height: 32px;
    }
  }
  &/deep/.el-message-box__btns .el-button--primary {
    &:hover {
      color: #fff;
    }
  }
  &/deep/.type_content {
    .el-input input {
      height: 34px !important;
      width: 240px !important;
    }
    .number_input input {
      width: 153px !important;
      height: 40px !important;
    }
    .floor-num input {
      width: 72px !important;
    }
  }
  &/deep/.goods-info {
    .ant-upload-list-picture-card-container {
      width: 80px;
      height: 80px;
    }
    .library-box {
      width: 80px;
      height: 80px;
      position: absolute;
      cursor: pointer;
    }
    .upload {
      .ant-upload.ant-upload-select-picture-card {
        border: 1px dashed #909399;
        border-radius: 2px;
        width: 80px;
        height: 80px;

        .anticon {
          font-size: 20px;
        }

        .ant-upload-text {
          font-size: 14px;
          height: 14px;
          line-height: 1;
        }
      }

      .ant-upload.ant-upload-select-picture-card:hover {
        border: 1px dashed #3455d3;

        .anticon {
          color: #3455d3;
        }

        .ant-upload-text {
          color: #3455d3;
          font-size: 14px;
          height: 14px;
          line-height: 1;
        }
      }

      .ant-upload-list-picture-card .ant-upload-list-item {
        width: 80px;
        height: 80px;
      }

      .ant-upload-list-item-info {
        width: 100%;

        & > span {
          width: 100%;
          height: 100%;
        }
      }

      .ant-upload-list-picture-card .ant-upload-list-item-info {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
  .address-module {
    // border-bottom: 1px dashed #dcdfe6;
    // margin-bottom: 16px;
    // padding-bottom: 20px;
    width: 319px;
    margin-right: 36px;
    .address-module-inp {
      height: 81px;
      // margin-top: 11px;
      margin-bottom: 16px;
      &/deep/textarea {
        resize: none;
        height: 81px;
        border-radius: 0;
        line-height: 18px;
        font-size: 14px;
        padding: 10px 20px;
        &::-webkit-scrollbar {
          display: none;
        }
        &:focus,
        &:hover {
          border-color: #3455d3 !important;
        }
      }
    }
    &/deep/.el-button {
      width: 81px;
      height: 30px;
      border-color: #bec0c6;
      color: #5e6066;
      font-size: 12px;
      padding: 0;
      border-radius: 2px;
      &.identify {
        background: #3455d3;
        border-color: #3455d3;
        color: #fff;
        width: 103px;
      }
      &.is-disabled {
        background: #9fade1 !important;
        color: #fff;
        border-color: #9fade1;
        &:focus,
        &:hover {
          color: #fff !important;
          border-color: #bec0c6 !important;
        }
      }
    }
  }
  .type_content {
    .icona_xiadan_delete {
      top: 26px;
      left: 37px;
    }
  }
  .video_delete {
    &/deep/.ant-upload-list-item-card-actions {
      display: none;
    }
  }
  .user-info-box {
    display: flex;
  }
  .kehu-box {
    margin-bottom: 16px;
    height: 34px;
    &.address-box {
      flex-direction: column;
      // margin-bottom: 32px;
      min-height: 34px;
      height: auto;
      .kehu-tips {
        color: #ffad16;
        font-size: 12px;
        line-height: 16px;
        margin-left: 82px;
        margin-top: 8px;
      }
    }
    .tihuo {
      font-size: 12px;
      line-height: 16px;
      color: #5e6066;
      margin-left: 8px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      span {
        color: #ffad16;
      }
    }
    &:last-child {
      margin-bottom: 0;
    }
    .wulxinx {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .service_category {
    .huowu-tit {
      justify-content: flex-start;

      span {
        color: #f75658;
        font-size: 12px;
        margin-left: 24px;
      }
    }
    .service_category_info {
      padding-top: 20px;
      padding-bottom: 20px;
    }
    .map-box {
      height: 235px;
      width: 1200px;
      padding: 0;
      .yujishij {
        position: absolute;
        top: 0.5em;
        right: 3em;
        z-index: 10;
        background: #fff;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
        border-radius: 2px;
        padding: 8px;
        font-size: 14px;
        line-height: 14px;
        color: #5e6066;
        span {
          color: #3455d3;
        }
      }
    }

    /deep/.input_numbers {
      .number_input {
        width: 153px;
        margin-left: 10px;
        line-height: 32px;

        input {
          height: 34px !important;
          border-radius: 2px;
          border: 1px solid rgba(220, 223, 230, 1);
          padding: 0;
        }
      }

      .el-input.is-active .el-input__inner,
      .el-input__inner:focus {
        border-color: #3455d3 !important;
      }

      input:hover {
        border-color: #b4b7bc !important;
      }
    }
    .goods-text .info_settype {
      margin-bottom: 0;
    }
    .miaosu {
      .el-input__inner {
        width: 597px !important;
      }
    }
  }
  .tihuo-box {
    flex-direction: column;
  }
  .tihuo-info {
    display: flex;
    align-items: center;
    padding-left: 82px;
    .imgs {
      max-width: 432px;
      margin-right: 8px;
      display: flex;
      &/deep/.el-image {
        margin-left: 8px;
        &:first-child {
          margin-left: 0;
        }
      }
    }
    .tihuo-des {
      max-width: 950px;
      height: 100px;
      background: #f5f7fa;
      padding: 14px 12px;
      box-sizing: border-box;
      .tihuo-label {
        display: flex;
        margin-top: 12px;
        &:first-child {
          margin-top: 0;
        }
        & > div:first-child {
          margin-left: 0;
        }
        & > div {
          margin-left: 30px;
          font-size: 12px;
          line-height: 16px;
          color: #909399;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          span {
            color: #2f3133;
            margin-left: 16px;
          }
        }
      }
    }
  }
  .hexiao {
    .el-radio {
      margin-left: 16px;
      /deep/ .el-radio__inner:hover {
        border-color: #3455d3;
      }
      &:first-child {
        margin-left: 0;
      }
      /deep/.el-radio__label {
        color: #909399;
      }
    }
  }
  .bucong-desc {
    .el-input {
      /deep/.el-input__inner {
        width: 598px !important;
      }
    }
  }
  .speed_order_price {
    margin-top: 10px;
    .price_tabs {
      background: #ffffff;
      padding: 20px 63px 17px 820px;
      & > div {
        width: 316px;
        font-size: 14px;
        line-height: 14px;
        color: #2f3133;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          min-width: 84px;
          text-align: right;
        }
        margin-bottom: 12px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .total_price {
      height: 60px;
      padding: 14px 63px 14px 0;
      background: #f5f7fa;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .kehu_address {
        text-align: right;
        color: #909399;
        font-size: 12px;
        height: 32px;
        margin-right: 10px;
        & > div {
          line-height: 16px;
        }
      }
      .total_price_text {
        & > div {
          width: 316px;
          font-size: 14px;
          line-height: 14px;
          color: #2f3133;
          display: flex;
          justify-content: space-between;
          align-items: center;
          span {
            min-width: 84px;
            text-align: right;
          }
          i {
            font-style: normal;
            color: #f75658;
            font-size: 32px;
            line-height: 32px;
            font-weight: 600;
          }
        }
      }
    }
  }
}
</style>
